import React from 'react';
import century from '../assets/icon/toko/century.png';
import guardian from '../assets/icon/toko/guardian.png';
import k24 from '../assets/icon/toko/k24.png';
import kalbeconsumer from '../assets/icon/toko/kalbeconsumer.png';
import kimiafarma from '../assets/icon/toko/kimia farma.png';
import shopee from '../assets/icon/toko/shopee.png';
import toped from '../assets/icon/toko/toped.png';
import ig from '../assets/icon/toko/ig.png';
import watson from '../assets/icon/toko/watson.png';
import indomaret from '../assets/icon/toko/indo.png';
import alfamart from '../assets/icon/toko/alfa.png';



const igIcon = {
  src: ig,
  alt: 'Instagram',
  url: 'https://www.instagram.com/kalpanax_id/'
};

const logos = [
  // {
  //   src: kalbeconsumer,
  //   alt: 'Kalbe Consumer',
  //   url: 'https://www.kalbeconsumerhealth.com/en/brands/digestive-and-skin/kalpanax'
  // },
  {
    src: shopee,
    alt: 'Shopee',
    url: ' https://shopee.co.id/sakafarma?shopCollection=250870675#product_list'
  },
  {
    src: toped,
    alt: 'Tokopedia',
    url: 'https://www.tokopedia.com/kalbeconsumer/etalase/salep-anti-jamur'
  },
  { src: k24, alt: 'K24', url: '' },
  { src: watson, alt: 'Watson', url: '' },
  { src: century, alt: 'Century', url: '' },

  { src: kimiafarma, alt: 'Kimia Farma', url: '' },
  { src: guardian, alt: 'Guardian', url: '' },

  { src: indomaret, alt: 'Indomaret', url: '' },
  { src: alfamart, alt: 'Alfamart', url: '' }
];

const logos1 = [
  // {
  //   src: kalbeconsumer,
  //   alt: 'Kalbe Consumer',
  //   url: 'https://www.kalbeconsumerhealth.com/en/brands/digestive-and-skin/kalpanax'
  // },
  {
    src: shopee,
    alt: 'Shopee',
    url: ' https://shopee.co.id/sakafarma?shopCollection=250870675#product_list'
  },
  {
    src: toped,
    alt: 'Tokopedia',
    url: 'https://www.tokopedia.com/kalbeconsumer/etalase/salep-anti-jamur'
  },
  { src: k24, alt: 'K24', url: '' }
];

const logos2 = [
  { src: guardian, alt: 'Guardian', url: '' },
  { src: kimiafarma, alt: 'Kimia Farma', url: '' },

  { src: century, alt: 'Century', url: '' },
  { src: watson, alt: 'Watson', url: '' }
];

const LogoList = () => {
  return (
    <div className="bg-white rounded-xl grid md:grid-cols-2 gap-5">
      <div>
        <div className="flex justify-start items-center space-x-2">
          <h3 className="font-medium text-lg text-textBlack">
            Dapat dibeli di:
          </h3>
        </div>

        <div className="hidden md:flex flex-wrap justify-start gap-3 mt-2">
          {logos.map((logo, index) => {
            if (logo.url != '') {
              return (
                <a
                  href={logo.url}
                  target="_blank"
                  key={index}
                  className="flex justify-center items-center h-9"
                  rel="noreferrer">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-full w-auto"
                  />
                </a>
              );
            } else {
              return (
                <div
                  key={index}
                  className="flex justify-center items-center h-9"
                  rel="noreferrer">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-full w-auto"
                  />
                </div>
              );
            }
          })}
        </div>

        {/* <div className="hidden md:flex flex-wrap justify-start gap-5 mt-2">
          {logos2.map((logo, index) => {
            if (logo.url != '') {
              return (
                <a
                  href={logo.url}
                  target="_blank"
                  key={index}
                  className="flex justify-center items-center h-9"
                  rel="noreferrer">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-full w-auto"
                  />
                </a>
              );
            } else {
              return (
                <div
                  key={index}
                  className="flex justify-center items-center h-9"
                  rel="noreferrer">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-full w-auto"
                  />
                </div>
              );
            }
          })}
        </div> */}

        <div className="md:hidden flex flex-wrap justify-start gap-5 mt-2">
          {logos.map((logo, index) => {
            if (logo.url != '') {
              return (
                <a
                  href={logo.url}
                  target="_blank"
                  key={index}
                  className="flex justify-center items-center h-9"
                  rel="noreferrer">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-full w-auto"
                  />
                </a>
              );
            } else {
              return (
                <div
                  key={index}
                  className="flex justify-center items-center h-9"
                  rel="noreferrer">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-full w-auto"
                  />
                </div>
              );
            }
          })}
        </div>
      </div>

      <div>
        <div className="flex flex-col justify-start items-start ">
          <h3 className="font-medium text-lg text-textBlack">
            Sosial media kami:
          </h3>
          <div className="flex justify-start items-center w-full mt-2">
            <a
              href={igIcon.url}
              target="_blank"
              className="flex justify-start items-center h-9 mr-2"
              rel="noreferrer">
              <img
                src={igIcon.src}
                alt={igIcon.alt}
                className="h-full w-auto"
              />
            </a>
            <a href={igIcon.url} target="_blank" rel="noreferrer">
              <span className="font-semibold text-black">@kalpanax_id</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoList;
